<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {PagerHtmlItem} from "@/types";

export default defineComponent({
    name: "PagerHtmlItem",
    props: {
        pagerItem: {
            type: Object as PropType<PagerHtmlItem>,
            required: true,
        },
        key: {
            type: String,
            required: true,
        }
    }
})
</script>

<template>
    <button :key="key" class="AppPager-dots" type="button">
        <span v-html="pagerItem.html"></span>
    </button>
</template>